module.exports = __webpack_public_path__ + "img/42.63d23774.svg";